import { render } from "./EditContentModal.vue?vue&type=template&id=04febc21"
import script from "./EditContentModal.vue?vue&type=script&lang=js"
export * from "./EditContentModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__